// All content scraped from yellowvideoproduction.com
// Vimeo IDs, client testimonials, services text preserved verbatim.

// Pre-resolved Vimeo CDN thumbnails (fetched via oEmbed).
// Empty/missing IDs gracefully fall back to the designed play-button card.
export const THUMBS = {
  // Showreel + service pages
  "286504818": "/thumbs/286504818.jpg",
  "195550505": "/thumbs/195550505.jpg",
  "48966657": "/thumbs/48966657.jpg",
  "195552565": "/thumbs/195552565.jpg",
  "524247054": "/thumbs/524247054.jpg",
  "195555367": "/thumbs/195555367.jpg",
  "292730785": "/thumbs/292730785.jpg",
  "665944961": "/thumbs/665944961.jpg",
  "173910751": "/thumbs/173910751.jpg",
  "294561716": "/thumbs/294561716.jpg",
  "195544502": "/thumbs/195544502.jpg",
  "395200384": "/thumbs/395200384.jpg",
  "195540040": "/thumbs/195540040.jpg",
  "228503070": "/thumbs/228503070.jpg",
  "485528301": "/thumbs/485528301.jpg",
  "173923753": "/thumbs/173923753.jpg",
  "255371585": "/thumbs/255371585.jpg",
  "316541640": "/thumbs/316541640.jpg",
  // Home page additions (Feb 2026)
  "673578319": "/thumbs/673578319.jpg",
  "457819085": "/thumbs/457819085.jpg",
  "359293952": "/thumbs/359293952.jpg",
  "330756428": "/thumbs/330756428.jpg",
  "579866596": "/thumbs/579866596.jpg",
  "709009126": "/thumbs/709009126.jpg",
  "776277082": "/thumbs/776277082.jpg",
  "919659479": "/thumbs/919659479.jpg",
  "141647881": "/thumbs/141647881.jpg",
  "786931941": "/thumbs/786931941.jpg",
  "292901353": "/thumbs/292901353.jpg",
  "346191730": "/thumbs/346191730.jpg",
  "646009344": "/thumbs/646009344.jpg",
  "468864496": "/thumbs/468864496.jpg",
};

export const SITE = {
  name: "Yellow",
  fullName: "Yellow Video Production",
  tagline: "Video Production Liverpool",
  phone: "0151 427 2900",
  email: "info@yellowvideoproduction.com",
  address1: "2nd Floor, Consortia House, 6 Columbus Quay, Liverpool L3 4DB",
  oldDomain: "https://www.yellowvideoproduction.com",
  social: {
    facebook: "https://www.facebook.com/YellowVideoProduction/",
    twitter: "https://twitter.com/yellowmp",
    linkedin: "https://uk.linkedin.com/company/new-reality-media",
  },
};

export const NAV = [
  { label: "Home", path: "/" },
  { label: "Video Production", path: "/video-production-in-liverpool" },
  { label: "Photography", path: "/photography-liverpool" },
  { label: "Animation", path: "/animation-liverpool" },
  { label: "Drone", path: "/drone-filming-aerial-photography-liverpool" },
  { label: "White Label", path: "/white-label" },
  { label: "Prices", path: "/video-production-prices" },
  { label: "Showreel", path: "/showreel" },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

// Featured hero reel for home page
// Hero background reel. Uses YouTube if HERO_REEL_YOUTUBE_ID is set, else Vimeo.
export const HERO_REEL_VIMEO_ID = "646009344";
export const HERO_REEL_YOUTUBE_ID = "GPwWTT5rdro";
export const HERO_POSTER = "/thumbs/hero-GPwWTT5rdro.jpg";

// Client logos cached locally (originals were hosted on the old WP site, which
// is no longer reachable now that the domain points at this app).
const L = "/wp-cache";
export const CLIENTS = [
  { name: "University of Liverpool", logo: `${L}/web-logo-uni.jpg` },
  { name: "Argos", logo: `${L}/web-logo-arg.png` },
  { name: "Land Rover", logo: `${L}/web-logo-land-1.png` },
  { name: "NHS", logo: `${L}/web-logo-nhs.jpg` },
  { name: "Aldi", logo: `${L}/web-logo-aldi.jpg` },
  { name: "University of Chester", logo: `${L}/web-logo-uni-chester.jpg` },
  { name: "Metropolitan Police", logo: `${L}/web-logo-met-police.jpg` },
  { name: "Q", logo: `${L}/web-logo-q.jpg` },
];

// 22 showreel projects, each with Vimeo ID + description (from old site)
export const SHOWREEL = [
  {
    id: "286504818",
    title: "Yellow Showreel",
    client: "Yellow Video Production",
    summary:
      "A taste of the work we've produced for global brands, universities, government agencies, charities and SMEs.",
  },
  {
    id: "292730785",
    youtube: "VMS8VYgfXJI",
    title: "MADE",
    client: "MADE at Moddershall Oaks",
    summary:
      "MADE wanted to show off their amazing new facilities, the wide variety of activities available and how they were focused on improving their client's health and well-being as a whole. A fresh and modern promotional film.",
  },
  {
    id: "173923753",
    youtube: "vl_7O_MtES4",
    title: "Liverpool John Moores University",
    client: "LJMU",
    summary:
      "LJMU received funding to promote their outreach work in the Liverpool area, educating high school children from lower-income families on the benefits of University.",
  },
  {
    id: "524247054",
    youtube: "NJrWPJTgE9s",
    title: "Amplifon",
    client: "Amplifon: Dedicated to Better Hearing",
    summary:
      "Video content to accompany Amplifon's 'Dedicated to Better Hearing' summer campaign, aimed at people thinking about using hearing aids for the first time.",
  },
  {
    id: "511209629",
    youtube: "c_9NzJ1Ymps",
    title: "Liverpool Hope University",
    client: "Liverpool Hope University",
    summary:
      "A series of films for Hope's 'Say Yes' campaign, students from across the university telling their stories in their own words.",
  },
  {
    id: "195555367",
    title: "DeTrafford",
    client: "DeTrafford: Property Developer",
    summary:
      "Quarterly updates on the building of new properties for investors, mixing drone footage and on-site camera crew to show progress and quality.",
  },
  {
    id: "228503070",
    youtube: "dgXHDn_88q4",
    title: "Persil: Cook With Kids",
    client: "Persil / Unilever",
    summary:
      "A 5-part 'cook along' series with a children's cooking expert taking parents through creative and messy recipes, produced with Unilever's PR team.",
  },
  {
    id: "48966657",
    youtube: "taG4JO3mLxI",
    title: "Cancer Research UK",
    client: "Cancer Research UK",
    summary:
      "An awareness video for protection from skin cancer, with medical experts and survivors explaining what to look out for and how to protect yourself.",
  },
  {
    id: "457819085",
    youtube: "ReXTEvyoXWw",
    title: "Aldi: Winter Range",
    client: "Aldi",
    summary:
      "A video promoting Aldi's Winter/Christmas range, building excitement and buzz behind all the new products included in the offering.",
  },
  {
    id: "294561716",
    youtube: "zZdXgxszBIU",
    title: "Dreamland",
    client: "Dreamland: Electric Blankets",
    summary:
      "Showcasing the variety of Dreamland's unique blankets and throws in a short, elegant, model-led piece using graphics rather than VO.",
  },
  {
    id: "395200384",
    title: "Oven Pride",
    client: "Oven Pride",
    summary:
      "An updated 'how to use' film with a brand ambassador presenting the product and walking viewers through every stage of the cleaning process.",
  },
  {
    id: "195544502",
    youtube: "OJ1hZDkwUSU",
    title: "T3DMC",
    client: "The 3D Measurement Group",
    summary:
      "A product demo of T3DMC's hand-held 3D scanners, using video and graphics to show capabilities that previously required huge machines.",
  },
  {
    id: "330756428",
    youtube: "COfnv1gsbzg",
    title: "Decor Academy",
    client: "Decor Group: Interior Design",
    summary:
      "A promotional film highlighting the benefits of Decor's Creative Academy for students aged 17–25 as an alternative to university.",
  },
  {
    id: "579866596",
    youtube: "yqP-c4fFPpQ",
    title: "Wed4Less",
    client: "Wed4Less: Bridal",
    summary:
      "An elegant, slow-motion film showing dress styles for ladies of all sizes, designed to feel premium despite a discount-store brand.",
  },
  {
    id: "195552565",
    youtube: "9TVw8ant7WE",
    title: "The English Cake Co.",
    client: "The English Cake Company",
    summary:
      "Showing the effort and love that goes into every cake, a sumptuous brand piece for a new pre-packaged baking range.",
  },
  {
    id: "631980899",
    title: "Community Foundation for Merseyside",
    client: "CFM",
    summary:
      "Working with Jamie Carragher's 23 Foundation, this film shows how donations support amazing causes across Liverpool and the surrounding areas.",
  },
  {
    id: "359293952",
    title: "Bob's Business",
    client: "Bob's Business: Cyber Security",
    summary:
      "Animation and motion graphics that simply explain a complex cyber-security offer, designed to be friendly to non-technical audiences.",
  },
  {
    id: "631168832",
    youtube: "-71m_dBfOnU",
    title: "Hoya Lens UK",
    client: "Hoya Lens",
    summary:
      "A customer-testimonial film for global lens manufacturer Hoya Lens, showing how their service goes far above anything competitors offer.",
  },
  {
    id: "295193734",
    title: "One Wirral CIC",
    client: "One Wirral CIC",
    summary:
      "An awareness campaign showing how being more active can help with recovery from chemotherapy and cancer surgeries.",
  },
  {
    id: "173910751",
    youtube: "giYPbs9zJeQ",
    title: "Onward Homes",
    client: "Onward Homes",
    summary:
      "Introducing Onward's in-house team, the beating heart of the business, showing the type of work they do for their residents.",
  },
  {
    id: "195540040",
    title: "Shelfspan",
    client: "Shelfspan",
    summary:
      "An animated product reel for exhibitions and trade shows, used as eye-catching screen content to attract foot traffic at the Shelfspan stall.",
  },
  {
    id: "286331479",
    title: "CleverBed",
    client: "Ninja Corp: CleverBed",
    summary:
      "A promotional product video for CleverBed, aimed at parents who wanted an alternative to bulky and difficult blow-up beds for their children.",
  },
];

// Service deep-cuts featured on Video Production page
export const VIDEO_PRODUCTION_FEATURES = [
  {
    id: "776277082",
    youtube: "kHMDPuLuMjA",
    title: "Interviews with members of your team",
    body:
      "We guarantee the reason that customers come BACK to you is not because of your products or service, but because of your people, their dedication, humour, passion and willingness to help. If that's the case, it's a huge mistake to not showcase the talent of your people.",
  },
  {
    id: "292730785",
    youtube: "VMS8VYgfXJI",
    title: "Montages of your services and products in practice",
    body:
      "If you believe in your products or services, show them off! We use inspiring, dynamic imagery to show your audience exactly how you do things, and to give them a flavour of how exciting it is to work with you.",
  },
  {
    id: "173923753",
    youtube: "vl_7O_MtES4",
    title: "Testimonials from your customers",
    body:
      "The world is sceptical when it comes to old-fashioned marketing. Potential customers won't believe how good you are without a 2nd opinion. Let your most satisfied customers do the selling for you.",
  },
  {
    id: "673578319",
    youtube: "iXfKwkxJY6k",
    title: "Infographics, motion graphics and CGI",
    body:
      "We can include motion graphics and computer imagery to take your branding to another level, explaining complicated services simply, showing the inside of new products, or visualising statistics quickly and effectively.",
  },
  {
    id: "228503070",
    youtube: "dgXHDn_88q4",
    title: "Event highlights",
    body:
      "Not everyone can make your event, open day, trade show or conference, so show off what they missed! Video gives an amazing overview of your event AND shows the emotion, excitement, tears of joy, laughter, something only video can prove.",
  },
  {
    id: "665944961",
    youtube: "yQKd8RpkMQE",
    title: "Drone footage",
    body:
      "Drone footage is an amazing way to show off your property, facilities and events. It's quick, stylish, and only requires a licensed drone pilot (like Yellow's Keith Lupton) for health & safety and insurance.",
  },
];

// Animation page
export const ANIMATION = {
  reels: [
    {
      id: "195550505",
      youtube: "49OAVULf0JA",
      title: "2D Motion Graphics",
      body:
        "If you are looking to improve your branding and deliver information quickly and effectively, then a 2D animation is perfect for your requirements. We can also help you write a script and provide a VO artist.",
    },
    {
      id: "286331479",
      title: "3D Renderings",
      body:
        "If you have a product or facility that is difficult to film, or if you are looking to visualise what your designs could look like, we can produce perfect 3D renderings that can range from basic to photo-realistic.",
    },
    {
      id: "468864496",
      title: "Explainers & Infographics",
      body:
        "Yellow produces animation for promotional, educational, entertainment and instructional content. Whatever your budget, get in touch with your brief and we can produce a high-quality animation that suits your requirements.",
    },
  ],
};

// Drone page
export const DRONE = {
  reels: [
    { id: "665944961", youtube: "yQKd8RpkMQE", title: "Showreel: Aerial" },
    { id: "511209629", title: "DeTrafford Property" },
    { id: "511210430", title: "Event Aerial" },
    { id: "325493082", title: "Liverpool Aerial" },
  ],
};

// Testimonials (text on multiple service pages)
export const TESTIMONIALS = [
  {
    quote:
      "Yellow took our brief and ran with it. The whole crew was professional, quick and the final films exceeded what we'd hoped for. We've already booked them for the next campaign.",
    author: "Marketing Director",
    company: "Liverpool Hope University",
  },
  {
    quote:
      "Everything from script to screen was handled, we just turned up and they made us look great. The free photography was a brilliant bonus and we still use the images two years later.",
    author: "Head of Comms",
    company: "Onward Homes",
  },
  {
    quote:
      "We've worked with a lot of agencies. Yellow is the only one that consistently delivers on time, on budget and to a quality we trust in front of our biggest clients.",
    author: "Creative Director",
    company: "White-Label Agency Partner",
  },
];


// Home page video rows (Feb 2026 refresh)
// Each video: { id, youtube?, title, client, h? } — `youtube` is the 11-char YouTube ID.
// If `youtube` is present, the modal plays YouTube; otherwise it falls back to Vimeo.
export const HOME_ROWS = {
  recent: {
    eyebrow: "Recent Work",
    title: "Recent work, hand-picked.",
    videos: [
      { id: "292730785", youtube: "vl_7O_MtES4", title: "LJMU", client: "Liverpool John Moores University" },
      { id: "286504818", youtube: "VMS8VYgfXJI", title: "MADE", client: "MADE at Moddershall Oaks" },
      { id: "524247054", youtube: "c_9NzJ1Ymps", title: "Liverpool Hope University", client: "Liverpool Hope University" },
      { id: "173923753", youtube: "NJrWPJTgE9s", title: "Amplifon", client: "Amplifon" },
      { id: "673578319", youtube: "iXfKwkxJY6k", title: "Zym", client: "Zym" },
    ],
  },
  brand: {
    eyebrow: "Big brand work",
    title: "Brand films & product stories.",
    videos: [
      { id: "195555367", youtube: "dgXHDn_88q4", title: "Persil", client: "Persil / Unilever" },
      { id: "173923753", youtube: "NJrWPJTgE9s", title: "Amplifon", client: "Amplifon" },
      { id: "228503070", youtube: "ReXTEvyoXWw", title: "Aldi", client: "Aldi" },
      { id: "48966657",  youtube: "taG4JO3mLxI", title: "Cancer Research UK", client: "Cancer Research UK" },
      { id: "457819085", youtube: "zZdXgxszBIU", title: "Dreamland", client: "Dreamland" },
      { id: "359293952", youtube: "-71m_dBfOnU", title: "Hoya Lens", client: "Hoya Lens" },
    ],
  },
  sme: {
    eyebrow: "SME Campaigns",
    title: "Bold films for ambitious smaller brands.",
    videos: [
      { id: "395200384", youtube: "OJ1hZDkwUSU", title: "T3DMC", client: "T3DMC" },
      { id: "330756428", youtube: "yqP-c4fFPpQ", title: "Wed4Less", client: "Wed4Less" },
      { id: "195544502", youtube: "COfnv1gsbzg", title: "Decor Academy", client: "Decor Group" },
      { id: "579866596", youtube: "9TVw8ant7WE", title: "The English Cake Co.", client: "The English Cake Co." },
      { id: "286504818", youtube: "VMS8VYgfXJI", title: "MADE", client: "MADE at Moddershall Oaks" },
      { id: "709009126", youtube: "0kgcvGToPQU", title: "Haldii", client: "Haldii" },
    ],
  },
  internal: {
    eyebrow: "Internal Communications",
    title: "Films that bring the workforce on side.",
    videos: [
      { id: "776277082", youtube: "kHMDPuLuMjA", title: "NHS", client: "NHS" },
      { id: "919659479", youtube: "VZoSUCLjShI", title: "Sheffield City Council", client: "Sheffield City Council" },
      { id: "141647881", youtube: "2RLQFYkUOc4", title: "Co-op", client: "Co-op" },
      { id: "786931941", youtube: "r6rftVcCe4k", title: "Medicash", client: "Medicash" },
      { id: "292901353", youtube: "giYPbs9zJeQ", title: "Onward Homes", client: "Onward Homes" },
    ],
  },
};


// Flat, deduplicated list of every video used across the home page rows,
// for the Showreel page grid. Preserves first-occurrence order.
export const ALL_HOME_VIDEOS = (() => {
  const seen = new Set();
  const out = [];
  ["recent", "brand", "sme", "internal"].forEach((key) => {
    HOME_ROWS[key].videos.forEach((v) => {
      if (!seen.has(v.id)) {
        seen.add(v.id);
        out.push(v);
      }
    });
  });
  return out;
})();
